<div class="center-align margin-top-20 margin-bottom-20"
    *ngIf="writeOffDataSource.data.length === 0 && networkCallInProgress">
    <mat-spinner [diameter]="35"></mat-spinner>
</div>
<div *ngIf="writeOffDataSource.data.length > 0">
    <mat-table #table [dataSource]="writeOffDataSource" class="finzyfont margin-top-20 margin-bottom-20"
        multiTemplateDataRows>
        <ng-container matColumnDef="writtenOffLoanId">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Loan ID</mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px"><a class="link"
                    [routerLink]="['/loandetail/'+element.loanIdentifier]"
                    target="_blank">{{element.writtenOffLoanId}}</a>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="writeOffStatus">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px"> Loan Classification</mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px">{{element.writeOffStatus}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="investmentDate">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Investment Date</mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px">{{element.investmentDate}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="investmentAmount">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Investment Amount</mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px">
                <app-indian-currency-formatter [amount]="element.investmentAmount"></app-indian-currency-formatter>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="receivedEMICount" style="margin-right: 20px">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">EMI Received count</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.receivedEMICount}} EMI(s)
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delayedEMICount">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Delayed EMIs count</mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px"> {{element.delayedEMICount}} EMI(s)
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="writeOffDate">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Write-Off Date</mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px"> {{element.writeOffDate}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="principalWrittenOff">
            <mat-header-cell *matHeaderCellDef style="margin-right: 20px">Principal Written-Off</mat-header-cell>
            <mat-cell *matCellDef="let element" style="margin-right: 20px">
                <app-indian-currency-formatter amount="{{element.principalWrittenOff}}"></app-indian-currency-formatter>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="accordion_arrow">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let element" style="justify-content: flex-end;max-width: 46px;">
                <mat-icon style="font-family: 'Material Icons';font-size: 18px;">{{element == expandedElement ?
                    'arrow_drop_up' : 'arrow_drop_down'}}
                </mat-icon>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let element">
                <div class="accordion-element-detail" *ngIf="isMobile"
                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Investment Amount
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <app-indian-currency-formatter [amount]="element.investmentAmount">
                                </app-indian-currency-formatter>
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            EMI Received count
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                {{element.receivedEMICount}} EMI(s)
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Delayed EMIs count
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                {{element.delayedEMICount}} EMI(s)
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Write-Off Date
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                {{element.writeOffDate}}
                            </span>
                        </div>
                    </div>
                    <div
                        style="display: flex; width:calc(100% - 16px);border-bottom: 1px solid #efefef;;line-height: 1;">
                        <div style="padding: 8px;width: 50%;">
                            Principal Written-Off
                        </div>
                        <div style="padding: 8px;width: 50%;">
                            <span>
                                <app-indian-currency-formatter amount="{{element.principalWrittenOff}}">
                                </app-indian-currency-formatter>
                            </span>
                        </div>
                    </div>



                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let element; columns: displayedColumns;" class="accordion-element-row"
            [class.accordion-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element"></mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']" class="accordion-detail-row">
        </mat-row>

    </mat-table>
</div>
<div class="text-center margin-top-20" *ngIf="!networkCallInProgress && writeOffDataSource.data.length === 0">
    <p><span>None of your investments have been written-off.</span></p>
    <button mat-flat-button class="primary" type="button" [routerLink]="['/investordashboard']">
        BACK TO DASHBOARD
    </button>
</div>